import './App.css';
import './utils/api'; // registers global axios auth interceptor
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import RepoDetails from './components/RepoDetails';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Repos from './components/Repos';
import React, { useState } from 'react';
import AiSettings from './components/ai/AiSettings';
import Dashboard from './components/Dashboard';
import PackageSearch from './components/PackageSearch';
import PackageImpactGraph from './components/PackageImpactGraph';
import SbomUpload from './components/SbomUpload';
import Docs from './components/Docs';
import IntelligenceDocs from './components/IntelligenceDocs';
import IntelligenceRuleRoadmap from './components/IntelligenceRuleRoadmap';
import VigilDocs from './components/VigilDocs';
import VigilTutorial from './components/VigilTutorial';
import VigilRuleDetail from './components/VigilRuleDetail';
import ComplianceMatrix from './components/ComplianceMatrix';
import CommercialRoadmap from './components/CommercialRoadmap';
import ProductPlan from './components/ProductPlan';
import ProductProgress from './components/ProductProgress';
import SupplierTrust from './components/SupplierTrust';
import CiSetup from './components/CiSetup';
import WebhookSettings from './components/WebhookSettings';
import RuleEditor from './components/RuleEditor';
import VigilScan from './components/VigilScan';
import VigilRuleBrowser from './components/VigilRuleBrowser';
import VigilScanHistory from './components/VigilScanHistory';
import VigilConceptBrowser from './components/VigilConceptBrowser';
import VigilAIQuery from './components/VigilAIQuery';
import VigilRuleSmith from './components/VigilRuleSmith';
import VigilRuleStudio from './components/VigilRuleStudio';
import VigilAcademy from './components/VigilAcademy';
import VigilTraceability from './components/VigilTraceability';
import VigilDesignReport from './components/VigilDesignReport';
import SecurityAgent from './components/SecurityAgent';
import CommandCenter from './components/CommandCenter';
import PricingPage from './components/PricingPage';
import WebsiteLayout from './components/website/WebsiteLayout';
import WebsiteHomePage from './components/website/WebsiteHomePage';
import WebsiteProductPage from './components/website/WebsiteProductPage';
import WebsiteVigilPage from './components/website/WebsiteVigilPage';
import WebsitePrismPage from './components/website/WebsitePrismPage';
import WebsiteDepGuardPage from './components/website/WebsiteDepGuardPage';
import WebsiteWhitepaperPage from './components/website/WebsiteWhitepaperPage';
import WebsitePricingPage from './components/website/WebsitePricingPage';
import WebsiteAboutPage from './components/website/WebsiteAboutPage';
import WebsiteKnowledgeHubPage from './components/website/WebsiteKnowledgeHubPage';
import WebsiteFaqPage from './components/website/WebsiteFaqPage';
import WebsiteArticlePage from './components/website/WebsiteArticlePage';
import WebsiteContactPage from './components/website/WebsiteContactPage';
import WebsiteIntegrationsPage from './components/website/WebsiteIntegrationsPage';
import WebsiteSecurityPage from './components/website/WebsiteSecurityPage';
import WebsiteEuCraPage from './components/website/WebsiteEuCraPage';
import WebsitePrivacyPage from './components/website/WebsitePrivacyPage';
import WebsiteTermsPage from './components/website/WebsiteTermsPage';
import LoginPage from './components/auth/LoginPage';
import TrialPage from './components/auth/TrialPage';
import ContactPage from './components/auth/ContactPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import UserManagement from './components/auth/UserManagement';
import { ToastProvider } from './components/common/ToastContext';
import { AuthProvider } from './context/AuthContext';
import { CommandPaletteProvider } from './context/CommandPaletteContext';
import CommandPalette from './components/CommandPalette';

function App() {
  const [loading, setLoading] = useState(false);
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <CommandPaletteProvider>
            <CommandPalette />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/trial" element={<TrialPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/website" element={<WebsiteLayout />}>
                <Route index element={<WebsiteHomePage />} />
                <Route path="product" element={<WebsiteProductPage />} />
                <Route path="product/depguard" element={<WebsiteDepGuardPage />} />
                <Route path="product/vigil" element={<WebsiteVigilPage />} />
                <Route path="product/prism" element={<WebsitePrismPage />} />
                <Route path="pricing" element={<WebsitePricingPage />} />
                <Route path="about" element={<WebsiteAboutPage />} />
                <Route path="knowledge" element={<WebsiteKnowledgeHubPage />} />
                <Route path="knowledge/:slug" element={<WebsiteArticlePage />} />
                <Route path="faq" element={<WebsiteFaqPage />} />
                <Route path="whitepaper" element={<WebsiteWhitepaperPage />} />
                <Route path="contact" element={<WebsiteContactPage />} />
                <Route path="integrations" element={<WebsiteIntegrationsPage />} />
                <Route path="security" element={<WebsiteSecurityPage />} />
                <Route path="eu-cra" element={<WebsiteEuCraPage />} />
                <Route path="privacy" element={<WebsitePrivacyPage />} />
                <Route path="terms" element={<WebsiteTermsPage />} />
              </Route>
              <Route path="/*" element={
                <ProtectedRoute>
                  <div className="App">
                    <Sidebar setLoading={setLoading} />
                    <main className="ce-main">
                      <Topbar />
                      <Routes>
                        <Route path="/" element={<Dashboard />} />
                        <Route path="/command-center" element={<CommandCenter />} />
                        <Route path="/repos" element={<Repos loading={loading} setLoading={setLoading} />} />
                        <Route path="/RepoDetails/:id" element={<RepoDetails />} />
                        <Route path="/ai/settings" element={<AiSettings />} />
                        <Route path="/packages" element={<PackageSearch />} />
                        <Route path="/impact" element={<PackageImpactGraph />} />
                        <Route path="/upload" element={<SbomUpload />} />
                        <Route path="/docs" element={<Docs />} />
                        <Route path="/docs/intelligence" element={<IntelligenceDocs />} />
                        <Route path="/docs/intelligence/rule-roadmap" element={<IntelligenceRuleRoadmap />} />
                        <Route path="/vigil/scan" element={<VigilScan />} />
                        <Route path="/vigil/rules" element={<VigilRuleBrowser />} />
                        <Route path="/vigil/rules/:ruleId" element={<VigilRuleDetail />} />
                        <Route path="/vigil/history" element={<VigilScanHistory />} />
                        <Route path="/vigil/concepts" element={<VigilConceptBrowser />} />
                        <Route path="/vigil/ai" element={<VigilAIQuery />} />
                        <Route path="/vigil/rulesmith" element={<VigilRuleSmith />} />
                        <Route path="/vigil/studio" element={<VigilRuleStudio />} />
                        <Route path="/vigil/academy" element={<VigilAcademy />} />
                        <Route path="/vigil/traceability" element={<VigilTraceability />} />
                        <Route path="/docs/vigil" element={<VigilDocs />} />
                        <Route path="/docs/vigil/tutorial" element={<VigilTutorial />} />
                        <Route path="/docs/vigil/design" element={<VigilDesignReport />} />
                        <Route path="/matrix" element={<ComplianceMatrix />} />
                        <Route path="/supplier-trust" element={<SupplierTrust />} />
                        <Route path="/progress" element={<ProductProgress />} />
                        <Route path="/roadmap" element={<CommercialRoadmap />} />
                        <Route path="/plan" element={<ProductPlan />} />
                        <Route path="/ci-setup" element={<CiSetup />} />
                        <Route path="/webhooks" element={<WebhookSettings />} />
                        <Route path="/rule-editor" element={<RuleEditor />} />
                        <Route path="/security/agent" element={<SecurityAgent />} />
                        <Route path="/pricing" element={<PricingPage />} />
                        <Route path="/admin/users" element={
                          <ProtectedRoute requiredRole="admin">
                            <UserManagement />
                          </ProtectedRoute>
                        } />
                      </Routes>
                    </main>
                  </div>
                </ProtectedRoute>
              } />
            </Routes>
          </CommandPaletteProvider>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
